module.exports = __webpack_public_path__ + "static/media/express.d638bd34.png";